import axiosInstance from "./axiosInstance";

export const getInspectionTemplates = async (token: string | null) => {
    const response = await axiosInstance.get(`/WorkOrders/GetInspectionTemplates`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
};
